import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=6b312c16&scoped=true"
import script from "./auth.vue?vue&type=script&lang=ts"
export * from "./auth.vue?vue&type=script&lang=ts"
import style0 from "./auth.vue?vue&type=style&index=0&id=6b312c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b312c16",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AContainer: require('/codebuild/output/src1816828197/src/app/components/atoms/Container/AContainer.vue').default})
